  // Sticky widget Style 2 icon library — consumed by sb-rfq-compact-v2.js / sb-rfq-multi-step-v2.js.
  window.SB_STICKY_ICONS = window.SB_STICKY_ICONS || {
    list:    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h2v2H3V5zm4 0h14v2H7V5zM3 11h2v2H3v-2zm4 0h14v2H7v-2zM3 17h2v2H3v-2zm4 0h14v2H7v-2z"/></svg>',
    form:    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zM8 13h8v2H8v-2zm0 4h5v2H8v-2z"/></svg>',
    cart:    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM1 2v2h2l3.6 7.59-1.35 2.44A2 2 0 0 0 7 17h12v-2H7.42a.25.25 0 0 1-.25-.25l.03-.12L8.1 13h7.45a2 2 0 0 0 1.75-1.03l3.58-6.49A1 1 0 0 0 20 4H5.21l-.94-2H1z"/></svg>',
    message: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM6 9h12v2H6V9zm0 4h8v2H6v-2z"/></svg>'
  };

  // Merchant Assurance sidebar icon library — consumed by sb-rfq-compact-v2.js / sb-rfq-multi-step-v2.js.
  // Keep keys in sync with $assuranceIconSvg in app/admin/merchant_assurance_settings.php.
  window.MERCHANT_ASSURANCE_ICONS = window.MERCHANT_ASSURANCE_ICONS || {
    'shield':         '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
    'clock':          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    'lock':           '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    'badge-check':    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>',
    'truck':          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="14" height="11" rx="1"/><path d="M15 9h4l3 3v5h-7z"/><circle cx="6.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>',
    'headset':        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 14v-2a9 9 0 0 1 18 0v2"/><path d="M3 14v3a2 2 0 0 0 2 2h2v-7H5a2 2 0 0 0-2 2z"/><path d="M21 14v3a2 2 0 0 1-2 2h-2v-7h2a2 2 0 0 1 2 2z"/><path d="M17 19v1a3 3 0 0 1-3 3h-2"/></svg>',
    'star':           '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    'dollar-sign':    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>',
    'phone':          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z"/></svg>',
    'mail':           '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>',
    'user-check':     '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></svg>',
    'award':          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>',
    'globe':          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',
    'message-circle': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
    'thumbs-up':      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>',
    'handshake':      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3-3.6 3.6"/><path d="M3 4h4l5 5"/><path d="m9 13-2.5-2.5a1 1 0 1 0-3 3L8 18a1 1 0 1 0 3-3"/></svg>'
  };

  var loadScript = function (url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (script.readyState) {
  script.onreadystatechange = function () {
  if (script.readyState == 'loaded' || script.readyState == 'complete') {
  script.onreadystatechange = null;
  callback();
  }
  };
  } else {
  script.onload = function () {
  callback();
  };
  }
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
  };
  // if (payment_status == 'active' || payment_status == 'trial' || payment_status == 'allow_store') {
    is_payment_enable = '1';
    if(typeof(sb_repload_script) == "undefined"){var sb_repload_script = "V0130426";}

    function _cfpStartInit() {
      if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
          jQuery191 = jQuery.noConflict(true);
          myAppJavaScript_cfp(jQuery191);
          sb_jQuery = jQuery191;
          (function() {
            loadrfqScriptFile();
          })();
        });
      } else {
        myAppJavaScript_cfp(jQuery);
        sb_jQuery = jQuery;
        (function() {
          loadrfqScriptFile();
        })();
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _cfpStartInit);
    } else {
      _cfpStartInit();
    }
    // }
    function loadrfqScriptFile() {

  var script = document.createElement('script');
  var shop = Shopify.shop;
  var isSpecialPlan = cfp_plan_name && cfp_plan_name.includes('cfp special');

  if (app_type === 'rfq') {

    if (shop === '088c1b-3.myshopify.com' && isSpecialPlan) {

      if (chooseFormOption === '0') {
        script.src = 'https://setubridgeapps.com/call-for-price/app/CFP-Extension/client-customization/088c1b-3/sb-rfq-extension.js?' + sb_repload_script;
      } else {
        script.src = 'https://setubridgeapps.com/call-for-price/app/CFP-Extension/client-customization/088c1b-3/sb-rfq_form_1.js?' + sb_repload_script;
      }

    } 
    else if (shop === 'tce3db-z3.myshopify.com' && isSpecialPlan) {

      script.src = 'https://setubridgeapps.com/call-for-price/app/CFP-Extension/client-customization/tce3db-z3/sb-rfq-extension-compact.js?' + sb_repload_script;

    } 
    else {

      /* if (chooseFormOption === '0') {
        script.src = "{{ 'sb-rfq-extension.js' | asset_url }}";
      } else {
        script.src = "{{ 'sb-rfq_form_1.js' | asset_url }}";
      } */

      /* script.src = "{{ 'sb-rfq-main.js' | asset_url }}"; */

      if (chooseFormOption === '0') {
        script.src = cfpAssets.rfqCompact;
      } else {
        script.src = cfpAssets.rfqMultiStep;
      } 
    }

  } 
  else {

    script.src = 'https://setubridgeapps.com/call-for-price/app/CFP-Extension/sb-cfp-extension.js?' + sb_repload_script;

  }

  document.head.appendChild(script);
}
  //
  // createStickyBanner();
  function myAppJavaScript_cfp($) {
  if (sb_cfp_enable == "1" && is_payment_enable == "1" && customer_visible =='1') {
  detectSocialPlatform = '';
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (userAgent.indexOf('Instagram') > -1) {detectSocialPlatform = 'Instagram';
  } else if (userAgent.indexOf('FBAN') > -1 || userAgent.indexOf('FBAV') > -1) {detectSocialPlatform = 'Facebook';
  } else if (userAgent.indexOf('Twitter') > -1) {detectSocialPlatform = 'Twitter';
  } else if (userAgent.indexOf('LinkedInApp') > -1) {detectSocialPlatform = 'LinkedIn';
  } else if (userAgent.indexOf('Pinterest') > -1) {detectSocialPlatform = 'Pinterest';
  } else if (userAgent.indexOf('Googlebot') > -1) {detectSocialPlatform = 'Google';
  } else {detectSocialPlatform = 'Online Store';}
  $(".cfp-sb-old-wrapper").remove(); $(".cfp-sb-old-modal-wrapper").remove(); //old store fix issue
    // Blanket hide-then-unhide removed — flicker source. Hide-price now handled
    // server-side in <head> via the SSR Liquid block at the top of this file.
    $("body").append(`<style>.cfp-prod-handle, .cfp-prod-url, .cfp-prod-title , .cfp-prod-id{display:none !important; } #Capa_1{width: 30px;height: 30px;margin-right: 10px;fill: #fff;transition:0.5s!important; } .cfp_call_button{    text-decoration: none;    color: inherit;}.cfp_call_button button{display:flex!important;justify-content:center!important;align-items:center!important;flex-direction:row!important;}.cfp-prod-button-call button:after {    content: none;} .request-for-quote-div button{content:none;} button.btn.Button.Button--primary.button.button--primary:after {    content: none;} .cfp-whatsapp{display: flex!important; justify-content: center; align-items: center!important;} @media screen and (max-width: 450px) { .cfp-whatsapp{padding: 0 5px 0 5px;display: flex!important;font-size: 12px;justify-content: space-evenly;} #Capa_1{width: 20px;height: 20px;margin-right: 0!important;fill: #fff;}}.call-for-price-btn{transition: 0.5s!important;display:flex!important;justify-content:center!important;align-items:center!important;flex-direction:row!important;z-index: 1!important;}.feather-phone-call{fill: ffffff!important;}@media screen and (max-width: 768px) {.whatsappResdesignWrapper{margin-right:10px;}  </style>`);
  setTimeout(function () {
  $("body").append(cfp_custom_css_style); $("body").append(cfp_custom_js_script);
  // cfp buttob_customization
      buttonStyles = '';
  if ((cfp_btn_customize_for !== "") && (cfp_btn_customize_for !== "undefined") && 
      ((cfp_btn_customize_for == 'customize_wp' && form_button_display_option =='show_cfp_whatsapp')
       || (cfp_btn_customize_for == 'customize_mail' && form_button_display_option =='show_cfp_form') || 
       (cfp_btn_customize_for == 'customize_call' && form_button_display_option =='show_cfp_button')  )) {
    if(cfp_btn_customize_for == 'customize_wp'){
      buttonStyles = 'padding:15px 20px 15px 20px;border-radius:50px;';
      $('body').append(`<style>div a:after {content: none;} a:after{content:none;}.card__heading a:after{content:none;}.card-wrapper .full-unstyled-link:after{content:none;}</style>`);
      $("body").append("<style>.cfp-whatsapp{border-radius:50px;}.call-for-price-btn:hover{background-color: " + cfp_bg_hvr_colorValue + "!important;color: " + cfp_text_hvr_colorValue + "!important}.call-for-price-btn:hover .email_icon_svg{fill: " + cfp_text_hvr_colorValue + "!important;transition: 0.5s!important;}.cfp-prod-button-call button:hover .feather-phone-call{fill: " + cfp_text_hvr_colorValue + "!important;transition: 0.5s!important;}.cfp-prod-button-call button:hover{background-color: " + cfp_bg_hvr_colorValue + "!important;color: " + cfp_text_hvr_colorValue + "!important;}.cfp-prod-button-call button{background-color: " + cfp_bg_colorValue + "!important;color: " + cfp_text_colorValue + "!important;display:flex;flex-direction:row;align-items:center;transition:0.5s!important} .feather-phone-call{margin: 0 0 0 0!important;fill: " + cfp_text_colorValue + "!important;transition:0.5s!important} .call-for-price-btn{background-color: " + cfp_bg_colorValue + "!important;color: " + cfp_text_colorValue + "!important;display:flex;flex-direction:row;align-items:center;}.email_icon_svg{fill: " + cfp_text_colorValue + "!important;margin: 0 8px 2px 0!important;}#Capa_1{fill: " + cfp_text_colorValue + "!important;}.call-for-price-btn:hover #Capa_1{fill: " + cfp_text_hvr_colorValue + "!important;transition: 0.5s!important;}</style>")
    }else{
      $('body').append(`<style>div a:after {content: none;} a:after{content:none;}.card__heading a:after{content:none;}.card-wrapper .full-unstyled-link:after{content:none;}</style>`);
      $("body").append("<style>.call-for-price-btn:hover{background-color: " + cfp_bg_hvr_colorValue + "!important;color: " + cfp_text_hvr_colorValue + "!important}.call-for-price-btn:hover .email_icon_svg{fill: " + cfp_text_hvr_colorValue + "!important;transition: 0.5s!important;}.cfp-prod-button-call button:hover .feather-phone-call{fill: " + cfp_text_hvr_colorValue + "!important;transition: 0.5s!important;}.cfp-prod-button-call button:hover{background-color: " + cfp_bg_hvr_colorValue + "!important;color: " + cfp_text_hvr_colorValue + "!important;}.cfp-prod-button-call button{background-color: " + cfp_bg_colorValue + "!important;color: " + cfp_text_colorValue + "!important;display:flex;flex-direction:row;align-items:center;transition:0.5s!important} .feather-phone-call{margin: 0 0 0 0!important;fill: " + cfp_text_colorValue + "!important;transition:0.5s!important} .call-for-price-btn{background-color: " + cfp_bg_colorValue + "!important;color: " + cfp_text_colorValue + "!important;display:flex;flex-direction:row;align-items:center;}.email_icon_svg{fill: " + cfp_text_colorValue + "!important;margin: 0 8px 2px 0!important;}#Capa_1{fill: " + cfp_text_colorValue + "!important;}.call-for-price-btn:hover #Capa_1{fill: " + cfp_text_hvr_colorValue + "!important;transition: 0.5s!important;}</style>");
      $("body").append(`<style>@media only screen and (max-width: 600px) {.powerd_logo {padding: 65px 0px !important;right: 0 !important;}.submitreq {z-index: 99999 !important;}}</style>`);
    }
  } else{
  $("body").append("<style>.feather-phone-call{margin: 0 10px 0 0!important; fill: #fff!important} .email_icon_svg{fill: #fff!important;margin: 0 8px 2px 0!important;}</style>")  
  }
  CFPcheckForProductPage();  CFPcheckForCollectionPage();

  // loadEventForm(); // cfpForm();
  // 800ms blanket un-hide setTimeout removed — paired with removed blanket hide above.
  }, timeDelay)
  // Re-inject CFP button after variant change re-renders the product section
  if(cfp_page_type == "product"){
  var cfpReinjectTimer = null;
  var cfpProductObserver = new MutationObserver(function() {
  if(cfpReinjectTimer) clearTimeout(cfpReinjectTimer);
  cfpReinjectTimer = setTimeout(function() {
  if($(".cfp-prod-wrapper-detail").length == 0 && $(".cfp-prod-wrapper-detail-call").length == 0) {
  CFPcheckForProductPage();
  } else if(typeof(doNotHidePrice) == 'undefined') {
  $('product-price[data-product-id="' + curr_hundle_pid + '"] [role="group"]').remove();
  }
  }, 300);
  });
  var observeTarget = document.querySelector('main') || document.querySelector('#MainContent') || document.body;
  cfpProductObserver.observe(observeTarget, { childList: true, subtree: true });
  }
  // Re-inject CFP/RFQ buttons after collection filters/sort/pagination re-render
  // the product grid via Shopify's Section Rendering API. CFPcheckForCollectionPage()
  // is idempotent (skips cards already marked with cfpCollectionLabelClass), so a
  // re-run only adds buttons to the freshly rendered cards. Honors doNotCheckFilter.
  if ((cfp_page_type == "collection" || cfp_page_type == "search" || cfp_page_type == "list-collections") && typeof doNotCheckFilter == "undefined") {
  var cfpCollReinjectTimer = null;
  var cfpCollCooling = false;
  var cfpRunCollectionReinject = function () {
  cfpCollCooling = true;
  CFPcheckForCollectionPage();
  setTimeout(function () { cfpCollCooling = false; }, 1600);
  };
  var cfpScheduleCollectionReinject = function () {
  if (cfpCollReinjectTimer) clearTimeout(cfpCollReinjectTimer);
  cfpCollReinjectTimer = setTimeout(cfpRunCollectionReinject, 500);
  };
  var cfpIsGridChange = function (mutations) {
  for (var i = 0; i < mutations.length; i++) {
  var added = mutations[i].addedNodes;
  for (var j = 0; j < added.length; j++) {
  var n = added[j];
  if (n.nodeType !== 1) continue;
  var cls = (n.className && n.className.toString) ? n.className.toString() : '';
  if (cls.indexOf('cfp-') !== -1) continue; // ignore our own injected nodes (avoid loops)
  if (n.matches && n.matches('a[href*="/products/"]')) return true;
  if (n.querySelector && n.querySelector('a[href*="/products/"]')) return true;
  }
  }
  return false;
  };
  var cfpCollObserver = new MutationObserver(function (mutations) {
  if (cfpCollCooling) return;
  if (cfpIsGridChange(mutations)) cfpScheduleCollectionReinject();
  });
  var cfpCollTarget = document.getElementById('MainContent') || document.querySelector('main') || document.body;
  cfpCollObserver.observe(cfpCollTarget, { childList: true, subtree: true });
  // Backups for themes whose facets don't swap a full DOM subtree
  $(document).on('click', '.js-filter, .active-facets, .facets__summary, .facet-checkbox, [data-sort-by], .facet-filters__sort', cfpScheduleCollectionReinject);
  $(document).on('input', '.facets, .field__input', cfpScheduleCollectionReinject);
  window.addEventListener('popstate', cfpScheduleCollectionReinject);
  }
  }
  // CFP detailpage Form
  function CFPcheckForCollectionPage() {
  if ($(".cfp_custom_position").length > 0) {
  $(".cfp_custom_position").each(function () {
  if (!$(this).hasClass('cfp-checked')) {
  var curr_this = $(this);
  var product_handle = $(this).attr('product_handle');
  var product_url = "/products/" + product_handle;
  try {
  fetch(product_url + ".json", {
  credentials: "same-origin"
  }).then(function (data) {
  data.json().then(function (data) {
  var get_product = data.product;
  var cfp_product_on = checkProductInCFP($,get_product.id,curr_this,get_product.tags,get_product.vendor);
  if (sb_cfp_enable == "1" && cfp_product_on) {
  var current_object = '';
  var isButtonPositionFound = true;
  specificThemePriceClass()
  current_object = appendCFPButtonCollection(curr_this);
  if (form_button_display_option == 'show_cfp_button') {
  var cfpButtonCollection =
  '<div class="cfp-prod-wrapper ' + get_product.handle + '" data-handle="' + collection_handle_sb + '" data-coll-id="' + collection_id + '">' +
  '<div class="cfp-prod-button-call">' +
  '<a class="cfp_call_button" target="_parent" href="tel:+' + phone_form_field_call + '"><button type="button" class="btn Button Button--primary button btn-primary button--primary"><svg width="24" height="24" class="feather-phone-call" xmlns="http://www.w3.org/2000/svg"><path d="M8.26 1.289l-1.564.772c-5.793 3.02 2.798 20.944 9.31 20.944.46 0 .904-.094 1.317-.284l1.542-.755-2.898-5.594-1.54.754c-.181.087-.384.134-.597.134-2.561 0-6.841-8.204-4.241-9.596l1.546-.763-2.875-5.612zm7.746 22.711c-5.68 0-12.221-11.114-12.221-17.832 0-2.419.833-4.146 2.457-4.992l2.382-1.176 3.857 7.347-2.437 1.201c-1.439.772 2.409 8.424 3.956 7.68l2.399-1.179 3.816 7.36s-2.36 1.162-2.476 1.215c-.547.251-1.129.376-1.733.376"/></svg>' + getTranslatedText("call-for-price-btn", selected_language, callforprice_label_call_button) + '</button></a>' +
  '</div>' +
  '</div>';
  } else {
  var cfpButtonCollection =
  '<div class="cfp-prod-wrapper ' + get_product.handle + ' ' + form_button_display_option + '" data-handle="' + collection_handle_sb + '" data-coll-id="' + collection_id + '">' +
  '<div class="cfp-prod-url">/products/' + get_product.handle + '</div>' +
  '<div class="cfp-prod-id">' + get_product.id + '</div>' +
  '<div class="cfp-prod-title">' + get_product.title + '</div>' +
  '<div class="cfp-prod-handle">' + get_product.handle + '</div>' +
  '<div class="cfp-prod-button">' +
  '<button type="button" style="' + buttonStyles + '" class="btn Button Button--primary button btn-primary button--primary call-for-price-btn ' + cfpwhatsapp + '">' + sb_cfp_btn_name + '</button>' +
  '</div>' +
  '</div>';
  }
  if(rfq_from_on_coll == "0"){
    var cfpButtonCollection = '';
  }
  if (current_object != '') {
  if (!$(curr_this).hasClass(cfpCollectionLabelClass)) {
  if ($('.cfp-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.cfp-prod-wrapper-detail').length > 0) {
  if ($('.cfp-prod-wrapper.' + get_product.handle).parent().parent().parent().find('.cfp-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.cfp-prod-wrapper-detail').length > 0) {
  $(".cfp_custom_position." + product_handle).html(cfpButtonCollection);
  } else {
  $(".cfp_custom_position." + product_handle).html(cfpButtonCollection);
  }
  } else {
  $(".cfp_custom_position." + product_handle).html(cfpButtonCollection);
  }
  if (typeof (doNotHidePrice) == 'undefined') {
  current_object.remove();
  }
  cfpHideAddToCartOnCollection($(curr_this));
  $(curr_this).addClass(cfpCollectionLabelClass);
  }
  }
  }
  })
  })
  } catch (e) { }
  }
  })
  } else {
  $("a").each(function () {
  var curr_this = $(this);
  var curr_href = curr_this.attr("href");
  var imgg = $(curr_this).closest('div').find('img').first();
  if (typeof curr_href !== 'undefined') {
  if (curr_href.indexOf("products/") >= 1 && $(this).parent().get(0).tagName != 'LI' && !$(this).hasClass('doNotAdd_cfp')) {
if (cfp_page_type == "product" && curr_href.includes("/" + product_handle_sb)) { return; }
  curr_href = curr_href.split("?")[0];
  fetch(curr_href + ".json", {
  credentials: "same-origin"
  }).then(function (data) {
  data.json().then(function (data) {
  var get_product = data.product;
  var cfp_product_on = checkProductInCFP($,get_product.id,curr_this,get_product.tags,get_product.vendor);
  if (sb_cfp_enable == "1" && cfp_product_on) {
  var current_object = '';
  var cfpProductPrice = 'price';
  var isButtonPositionFound = true;
  specificThemePriceClass()
  if ($(curr_this).find('img').first().length > 0) {
  if (!$(curr_this).find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this);
  $(curr_this).find('img').first().addClass(cfpCollectionLabelClass);
  }
  } else if ($(curr_this).closest('div').find('img').first().length > 0) {
  if (!$(curr_this).closest('div').find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this);
  $(curr_this).closest('div').find('img').first().addClass(cfpCollectionLabelClass);
  }
  } else if ($(curr_this).closest('div').parent().find('img').first().length > 0) {
  if (!$(curr_this).closest('div').parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this);
  $(curr_this).closest('div').parent().find('img').first().addClass(cfpCollectionLabelClass);
  }
  }
  else if ($(curr_this).closest('div').parent().parent().find('img').first().length > 0) {
  if (!$(curr_this).closest('div').parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this)
  $(curr_this).closest('div').parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
  }
  } else if ($(curr_this).closest('div').parent().parent().parent().find('img').first().length > 0) {
  if (!$(curr_this).closest('div').parent().parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this)
  $(curr_this).closest('div').parent().parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
  }
  } else if ($(curr_this).closest('div').parent().parent().parent().parent().find('img').first().length > 0) {
  if (!$(curr_this).closest('div').parent().parent().parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this)
  $(curr_this).closest('div').parent().parent().parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
  }
  } else if ($(curr_this).closest('div').parent().parent().parent().parent().parent().find('img').first().length > 0) {
  if (!$(curr_this).closest('div').parent().parent().parent().parent().parent().find('img').first().hasClass(cfpCollectionLabelClass)) {
  current_object = appendCFPButtonCollection(curr_this)
  $(curr_this).closest('div').parent().parent().parent().parent().parent().find('img').first().addClass(cfpCollectionLabelClass);
  }
  }
  if (form_button_display_option == 'show_cfp_button') {
  var cfpButtonCollection =
  '<div class="cfp-prod-wrapper ' + get_product.handle + '" data-handle="' + collection_handle_sb + '" data-coll-id="' + collection_id + '">' +
  '<div class="cfp-prod-button-call">' +
  '<a style="z-index:999999999999" class="cfp_call_button" target="_parent" href="tel:+' + phone_form_field_call + '"><button type="button" class="btn Button Button--primary button btn-primary button--primary"><svg width="24" height="24" class="feather-phone-call" xmlns="http://www.w3.org/2000/svg" "><path d="M8.26 1.289l-1.564.772c-5.793 3.02 2.798 20.944 9.31 20.944.46 0 .904-.094 1.317-.284l1.542-.755-2.898-5.594-1.54.754c-.181.087-.384.134-.597.134-2.561 0-6.841-8.204-4.241-9.596l1.546-.763-2.875-5.612zm7.746 22.711c-5.68 0-12.221-11.114-12.221-17.832 0-2.419.833-4.146 2.457-4.992l2.382-1.176 3.857 7.347-2.437 1.201c-1.439.772 2.409 8.424 3.956 7.68l2.399-1.179 3.816 7.36s-2.36 1.162-2.476 1.215c-.547.251-1.129.376-1.733.376"/></svg>' + getTranslatedText("call-for-price-btn", selected_language, callforprice_label_call_button) + '</button></a>' +
  '</div>' +
  '</div>';
  } else{
      var cfpButtonCollection =
      '<div class="cfp-prod-wrapper ' + get_product.handle + ' ' + form_button_display_option + '" data-handle="' + collection_handle_sb + '" data-coll-id="' + collection_id + '">' +
    '<div class="cfp-prod-url">/products/' + get_product.handle + '</div>' +
    '<div class="cfp-prod-id">' + get_product.id + '</div>' +
    '<div class="cfp-prod-title">' + get_product.title + '</div>' +
    '<div class="cfp-prod-handle">' + get_product.handle + '</div>' +
    '<div class="cfp-prod-button">' +
    '<button type="button" style="' + buttonStyles + '" class="btn Button Button--primary button btn-primary button--primary call-for-price-btn ' + cfpwhatsapp + '">' + sb_cfp_btn_name + '</button>' +
    '</div>' +
    '</div>';
    }
  if(rfq_from_on_coll == "0"){
    var cfpButtonCollection = '';
  }
  if (current_object != '') {
  if (!$(curr_this).hasClass(cfpCollectionLabelClass)) {
  $(curr_this).addClass(cfpCollectionLabelClass);
  if ($('.cfp-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.cfp-prod-wrapper-detail').length > 0 || current_object.parent().parent().parent().find('.cfp-prod-wrapper-detail-call').length > 0) {
  if ($('.cfp-prod-wrapper.' + get_product.handle).parent().parent().parent().find('.cfp-prod-wrapper.' + get_product.handle).length > 0 || current_object.parent().parent().parent().find('.cfp-prod-wrapper-detail').length > 0 || current_object.parent().parent().parent().find('.cfp-prod-wrapper-detail-call').length > 0) {
  } else {
  current_object.after(cfpButtonCollection);
  }
  //$('.cfp-prod-wrapper.'+get_product.handle)[1].remove();
  } else {
  current_object.after(cfpButtonCollection);
  }
  if (typeof (doNotHidePrice) == 'undefined') {
  current_object.remove();
  }
  cfpHideAddToCartOnCollection($(curr_this));
  }
  }
  }
  })
  })
  };
  }
  })
  }
  }

  function appendCFPButtonCollection(curr_this) {
  var cfpProductPrice = 'price';
  var cfpProductMoney = 'money';
  var current_object = '';
  var isTitleFound = false;
  // if (typeof (doNotHidePrice) !== 'undefined') { isTitleFound = true; current_object = curr_this.find('test'); }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').find('div,h3,h2,a,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().find('div,h3,h2,a,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().find('div,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().find('a,h2,h3,h4,h1,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find('div,h2,h3,a,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().find('div,h2,h3,a,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  if (!isTitleFound) {
  var divFind = $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().parent().find('div,h2,h3,a,span,ul,dl');
  current_object = searchCFPprice(divFind);
  if (current_object != '') { isTitleFound = true; }
  }
  return current_object;
  }
  function searchCFPprice(divFind) {
  var cfpProductPrice = 'price';
  var cfpProductMoney = 'money';
  var current_object = '';
  $(divFind).each(function (i) {
  var class_title = $(this).attr('class');
  if (typeof (class_title) != 'undefined') {
  if ((class_title.includes(cfpProductPrice) || class_title.includes(cfpProductMoney)) && (!class_title.includes("sb-not-price"))) {
  current_object = $(this)
  // $(this).hide(); // return current_object;
  return false;
  }
  }
  });
  return current_object;
  }
  function CFPcheckForProductPage() {
  // if (window.location.pathname.indexOf('/products/') !== -1) {
    if (cfp_page_type == "product") {
  var sb_cfp_current_collection_list_prodPage = filterConvertArray(cfp_current_collection_list_prodPage);
  var cfp_total_collection_list_prodPage = cfpcolIDSresults;
  var cfp_enabled = "no";
  //check for collection ids
  if (cfp_enabled != 'yes') {
  for (collection_name of cfp_total_collection_list_prodPage) {
  for (current_collection of sb_cfp_current_collection_list_prodPage) {
  if (current_collection.length >= 2 && collection_name.length >= 2) {
  if (current_collection.replace(/ /g, '') == collection_name.replace(/ /g, '')) {
  cfp_enabled = "yes";
  }
  }
  }
  }
  }
  //check all products
  if (sb_cfp_is_all_products == "1" && cfp_enabled != 'yes') { cfp_enabled = "yes"; }
  //check specific products
  if (cfpprodAllresults.includes(product_id_sb.toString()) && cfp_enabled != "yes") {
  cfp_enabled = "yes";
  }

  //check tags products
  var prodTagsArray = product_tags_sb.split(',');
  prodTagsArray = prodTagsArray.map(tag => tag.trim());
  prodTagsArray = prodTagsArray.filter(tag => tag !== "");     
  if (prodTagsArray.some(tag => sb_cfp_tags.includes(tag))) {
     cfp_enabled = "yes";
  }

  //check vendor products
  if (sb_cfp_vendor.includes(product_vendor_sb.trim())) {
    cfp_enabled = "yes";
  }
    
  if (cfp_enabled == "yes") {
  if(typeof(doNotHidePrice) == 'undefined' && $("#cfp-pdp-hide-price").length == 0){
  $("head").append('<style id="cfp-pdp-hide-price">product-price[data-product-id="' + curr_hundle_pid + '"] [role="group"], product-price[data-product-id="' + curr_hundle_pid + '"] .compare-at-price, product-price[data-product-id="' + curr_hundle_pid + '"] .price-item { display: none !important; }</style>');
  }
  //$('.csp-prod-wrapper.'+product_handle_sb).remove();
  if (form_button_display_option == 'show_cfp_button') {
  var addtocfpbutton =
  '<div class="cfp-prod-wrapper-detail-call">' +
  '<div class="cfp-prod-button-call">' +
  '<a class="cfp_call_button" target="_parent" href="tel:+' + phone_form_field_call + '"><button type="button" class="btn Button Button--primary button btn-primary button--primary"><svg width="24" height="24" class="feather-phone-call" xmlns="http://www.w3.org/2000/svg" "><path d="M8.26 1.289l-1.564.772c-5.793 3.02 2.798 20.944 9.31 20.944.46 0 .904-.094 1.317-.284l1.542-.755-2.898-5.594-1.54.754c-.181.087-.384.134-.597.134-2.561 0-6.841-8.204-4.241-9.596l1.546-.763-2.875-5.612zm7.746 22.711c-5.68 0-12.221-11.114-12.221-17.832 0-2.419.833-4.146 2.457-4.992l2.382-1.176 3.857 7.347-2.437 1.201c-1.439.772 2.409 8.424 3.956 7.68l2.399-1.179 3.816 7.36s-2.36 1.162-2.476 1.215c-.547.251-1.129.376-1.733.376"/></svg>' + getTranslatedText("call-for-price-btn", selected_language, callforprice_label_call_button) + '</button></a>' +
  '</div>' +
  '</div>';
  } else{
    var addtocfpbutton =
      '<div class="cfp-prod-wrapper-detail ' + form_button_display_option + '">' +
      '<div class="cfp-prod-url">' + product_url + '</div>' +
      '<div class="cfp-prod-id">' + curr_hundle_pid + '</div>' +
      '<div class="cfp-prod-title">' + curr_title_detailpge + '</div>' +
      '<div class="cfp-prod-handle">' + product_handle_sb + '</div>' +
      '<div class="cfp-prod-button">' +
      '<button type="button" style="' + buttonStyles + '" class="btn Button Button--primary button btn-primary button--primary call-for-price-btn ' + cfpwhatsapp + '"><div style="display: flex;align-items: center;">' + sb_cfp_btn_name + '</div></button>' +
      '</div>' +
      '</div>';
    
    }
  if(rfq_from_on_prod == "0"){
    var addtocfpbutton = '<div class="cfp-prod-wrapper-detail ' + form_button_display_option + '"></div>';
  } 
  var current_object_detail = '';
  $("form").each(function (index) {
  var getForm = $(this).attr("action");
  if (!(typeof (getForm) !== 'undefined') || $(this).hasClass("do_not_check")) {
  var getForm = '';
  }
  if (getForm.includes("/cart/add") && $(".cfp-prod-wrapper-detail").length == 0 && $(".cfp-prod-wrapper-detail-call").length == 0) {
      if($(".cfp-pdp-custom-position").length <= 0){$(this).after(addtocfpbutton);}
  $(".cfp-prod-button").show();
  specificThemePriceClass();
  // CFPhidePriceOnAllPages($(this));
  current_object_detail = appendCFPButtonCollection($(this));
  if (typeof (doNotHidePrice) == 'undefined') {
  if (current_object_detail == '') {
  CFPhidePriceOnAllPages($(this));
  }
  CFPhidePriceOnAllPages($(this)); //hide the price added class //05-09
  }
  var cfpdetaiilInForm = $('form[action*="/cart/add"]').find('.sb-call-for-price-title,.product-meta__title,.product-meta,.product__title,.gt_heading,.product-title,.product-single__title,.product-single__vendor,.cfp-pdp-custom-position')
  if (!(typeof (doNotHideaddtoCart) !== 'undefined')) {
  if (cfpdetaiilInForm.length > 0) {
  $('form[action*="/cart/add"]').find('button').not('.sb_cfp_btn_not_remove').remove(); //someone buys the product so remove the add to cart
  $('form[action*="/cart/add"]').find('input[type="submit"][name="button"]').remove(); // remove [name] if not working on any store
  } else {
  $(this).remove();//someone buys the product so remove the add to cart
  $('form[action*="/cart/add"]').remove();
  }
  }
  if($(".cfp-pdp-custom-position").length <= 0){}else{ $(".cfp-pdp-custom-position").append(addtocfpbutton);}

  // Move button to price area on themes with product-price element (ALWAYS)
  var cfpPriceEl = $('product-price[data-product-id="' + curr_hundle_pid + '"]');
  if(cfpPriceEl.length > 0) {
  var cfpBtn = $(".cfp-prod-wrapper-detail, .cfp-prod-wrapper-detail-call").first();
  if(cfpBtn.length > 0) {
  if(typeof(doNotHidePrice) == 'undefined') {
  cfpPriceEl.find('[role="group"]').remove();
  cfpPriceEl.append(cfpBtn);
  } else {
  cfpPriceEl.before(cfpBtn);
  }
  }
  }

  }
  });
  //remove price on detail page
  if (current_object_detail != '') {
  if (checkFreeTheme() && typeof (doNotHidePrice) == 'undefined') { //for free theme variant change price show issue 
  $("product-info .no-js-hidden").each(function () { if ($(this).find(".price").length > 0) { $(this).remove(); } })
  }
  // if (!current_object_detail.parent().hasClass('cfp-detail-checked')) {
  // current_object_detail.parent().addClass('cfp-detail-checked');
  if (typeof (doNotHidePrice) == 'undefined') {
  current_object_detail.remove();
  }
  // }
  }
  }
  else {
  $('form[action="/cart/add"]').show();
  }
  }
  }
  function specificThemePriceClass(){
  if(originThemeName == 'Warehouse'){
  hidePriceList_cfp += ',.price-list,.product-form__price-info';
  }
  if(originThemeName == 'Influence'){$("product-price").addClass('price');hidePriceList_cfp += ',.payment-buttons';}
  if(originThemeName == 'Kalles'){$(".t4s-sticky-atc__btns").remove();}
  if(originThemeName == 'Wokiee'){$(".tt-fixed-product-wrapper").remove();}
  if(originThemeName == 'Avone'){$(".stickyCart").remove();hidePriceList_cfp += ',.psinglePriceWr';}
  if(originThemeName == 'Prestige'){$(".product-sticky-bar").remove();}
  if(originThemeName == 'Leo ftshop 3'){$(".ap-productstickyform").remove();}
  }
  function CFPhidePriceOnAllPages(curr_this) {
  //if (typeof (doNotHidePrice) !== 'undefined') {return;}
  if ($(curr_this).find(hidePriceList_cfp).length > 0) {
  $(curr_this).find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').parent().find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').parent().find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').parent().parent().find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').parent().parent().find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').parent().parent().parent().find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').parent().parent().parent().find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').parent().parent().parent().find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').parent().parent().parent().find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').parent().parent().parent().parent().find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').parent().parent().parent().parent().find(hidePriceList_cfp).remove();
  } else if ($(curr_this).closest('div').parent().parent().parent().parent().parent().find(hidePriceList_cfp).length > 0) {
  $(curr_this).closest('div').parent().parent().parent().parent().parent().find(hidePriceList_cfp).remove();
  }
  }
  function cfpHideAddToCartOnCollection(curr_this) {
  var hideCartBuuton = 'form[action*="/cart/add"],.quick-view,.t4s-pr-quickview,.t4s-pr-addtocart,.add-to-cart,.quick-view-btn,.boost-pfs-quickview-btn,.quick-add,.product-form__quantity,.quickbuy-toggle,product-to-cart,.m-product-quickview-button,.tt-btn-quickview,.quickShop,.woodmart-buttons,.product-buttons,.product-cta,.product-cta-upright,.quickview-icon,.btn-quickview,.productitem--actions,.quick-product__btn,.product-item__quick-form';
  if ((typeof (doNotHideaddtoCart) !== 'undefined')) { var hideCartBuuton = 'NOT-HIDE'; }
  if ((typeof (doHideaddtoCartOnCollection) !== 'undefined')) { var hideCartBuuton = doHideaddtoCartOnCollection; }
  // var priceClass = '.price,.money';
  var priceClass = '.product-name,.title,.product-title,.sb-call-for-price-title,.product-single__title';

  if ($(curr_this).find(hideCartBuuton).length > 0) {
  if ($(curr_this).children().find(hideCartBuuton).find(priceClass).length <= 0) {
  $(curr_this).find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().find(hideCartBuuton).remove();
  }
  } else if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().parent().find(hideCartBuuton).length > 0) {
  if ($(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().parent().find(hideCartBuuton).children().find(priceClass).length <= 0) {
  $(curr_this).closest('div, product-card,.sb_collection_wrap').parent().parent().parent().parent().parent().find(hideCartBuuton).remove();
  }
  }
  }
  setTimeout(function () { hideSearchPrice($) }, 1000);
  }

 function checkProductInCFP($,productid,curr_this,prod_tags,prod_vendor){


  var product_match_sb = false;
  //check for collection
  // if (window.location.pathname.indexOf('/products/') == -1) {
    if(cfp_page_type != "product"){
  if (product_match_sb != true) {
  for (collection_ID of cfpcolIDSresults) {
  if (collection_ID.replace(/ /g, '') == collection_id && collection_id !="" && collection_ID != "") {
  product_match_sb = true;
  }
  }
  }
  }
      
  //check all products
  if (sb_cfp_is_all_products == "1" && product_match_sb != true) { product_match_sb = true; }
      
  //check specific products
  if (cfpprodAllresults.includes(productid.toString()) || sb_cfp_colAllresults.includes(productid.toString()) && product_match_sb != true) {
  product_match_sb = true;
  }
      
  // check products in collections
  if (product_match_sb != true) {
  $.each(sb_cfp_ProIDsCollectionsTest, function (key, value) {
  if (value.includes(productid.toString())) {
  var colid = key.split('_')[0]
  product_match_sb = true;
  }
  })
  }
      
  //check for all collection with theme attr
  var collection_id_liquid = $(curr_this).attr('collection-id');
  if (typeof collection_id_liquid != 'undefined') {
  collection_id_liquid = filterConvertArray(collection_id_liquid)
  if (product_match_sb != true) {
  for (collection_ID of cfpcolIDSresults) {
  if ($.inArray(collection_ID.replace(/ /g, ''), collection_id_liquid) != -1 && collection_ID != "") {
  product_match_sb = true;
  }
  }
  }
  }

    //check tags products
    if (prod_tags && typeof prod_tags === 'string') {
        var prodTagsArray = prod_tags.split(',');
        prodTagsArray = prodTagsArray.map(tag => tag.trim());
        prodTagsArray = prodTagsArray.filter(tag => tag !== "");
        if (prodTagsArray.some(tag => sb_cfp_tags.includes(tag))) {
            product_match_sb = true;
        }
    }

   //check vendor products
    if (prod_vendor && typeof prod_vendor === 'string' && sb_cfp_vendor.includes(prod_vendor.trim())) {
      product_match_sb = true;
    }
    
    return product_match_sb;
  }
    
  function setCookieCFP(name, value, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "; expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + "; path=/";
  }
  function getCookieCFP(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
  var c = ca[i];
  while (c.charAt(0) == ' ') c = c.substring(1, c.length);
  if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
  }
  function eraseCookieCFP(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  //sending whatsapp msg code
  function whatsAppChatRedirection(number, md, text) {
  var number2 = number.replace(/ +/g, "");
  if (md) {
  var mob = "https://wa.me/" + number2 + "?text=" + text;
  window.open(mob, "_blank");
  } else {
  var web = "https://"+sb_cfp_whatsapp_api+".whatsapp.com/send?phone=" + number2 + "&text=" + text;
  window.open(web, "wupwindow", "toolbar=yes,scrollbars=yes,resizable=yes,top=130,left=260,width=900,height=500");
  }
  }
  function checkFreeTheme() {
  var sb_cfp_freeThemes = ['Dawn', 'Refresh', 'Craft', 'Sense', 'Studio', 'Crave', 'Origin', 'Ride', 'Taste', 'Spotlight', 'Colorblock', 'Publisher'];
  if (sb_cfp_freeThemes.includes(originThemeName)) {
  return true;
  }
  return false;
  }

  function hideSearchPrice($) {
  $('.predictive-search__item-content .price').hide();
  }
  function checkPayemntCFP($) {
  var sb_payment_status_check = getCookieCFP('sb_payment_status_check_cfp');
  if (sb_payment_status_check == null) {
  $.ajax({
  url: "https://setubridgeapps.com/call-for-price/app/src/public/checkPaymentStatus",
  type: "GET",
  data: {
  shop: shop
  },
  cache: false,
  success: function (response) {
  if (response) {
  response = JSON.parse(response);
  if (response.result.status == "active") {
  setCookieCFP('sb_payment_status_check_cfp', 'active', 1);
  // myAppJavaScript_cfp($);// loadEventForm($);// functionForFilter($);
  } else {
  setCookieCFP('sb_payment_status_check_cfp', 'not_set', 1);
  }
  } else {
  setCookieCFP('sb_payment_status_check_cfp', 'not_set', 1);
  }
  //for Plus customer
  if (response.status == '1') {
  setCookieCFP('sb_payment_status_check_cfp', 'active', 1);
  // myAppJavaScript_cfp($);
  // loadEventForm($);
  // functionForFilter($)
  }
  }
  });
  }
  }
  // }
  // }
  // notes
  // 1. add (doNotAdd_cfp) class to a tag where you dont want checking
  // 2. custom position for cfp button on collection page (this will not check any a tag)
  // <div class="cfp_custom_position {{ product.handle }}" product_handle="{{ product.handle }}"></div>
  // 3. if do not want to hide then add this in theme.liquid
  // var doNotHidePrice = true ;
  // 4. add custom fields to form using this code add in theme.liquid
  // var cfp_additional_field=`<div class="form-group"><input type="number" placeholder="Your Postcode" name="addtional_fields[Postcode]" id="postcode"   class="cfp_field form-control formfield additional_require" additional_require_msg="This field is required" ></div> `;
  // 5. load functions late for store add this in theme.liquid
  // var timeDelay = 5000;
  // 6. if do not want to hide Add to cart button add this in theme.liquid
  // var doNotHideaddtoCart = true;
  //6. add attribute to a tag for all collection issue
  /*
  // collection-id="{{ productCollectionList }}"
  {% capture productCollectionList %}
  {% for collection_loop in product.collections %}
  {{- collection_loop.id -}}
  {% if forloop.last == false %},{% endif%}
  {% endfor %}
  {% endcapture %}
  */
  // 7. add this div for custom position on pdp page 
  // <div class="cfp-pdp-custom-position"></div>
  // 7. add class to this variable to hide any item on collection page like addtocart if using doNotHideaddtoCart or not
  // var doHideaddtoCartOnCollection = '.product-item__quick-form';
  // 8. add this variable doNotCheckFilter to excude execution of functionForFilter()
  // var doNotCheckFilter = '';
  // 9. add this class (sb_cfp_btn_not_remove) in the form if form have title and hiding buttons like cfp button or variant btn
  // 10. add this in theme.liquid if you want to remove field nd require validation for  Email and Name fields
  // var sb_cfp_do_not_show_fields = 'email,name';
  // var sb_cfp_do_not_require_fields = 'email';
  // 11. add in theme if having redirect issue on iphone pro model, this will change web. to api.
  // var sb_cfp_whatsapp_api = 'api';
  // 12. do not hide price on load for blink price issue
  // var doNotHidePriceOnRefresh = true;
  // 13. define this variable if want to remove products from cart 
  // var prevent_cart = true; // this will remove all products from cart page only
  // var prevent_cart_all_page = true; // this will remove all products from all pages
